import styled from "styled-components";

const HeaderSpan = styled.span`
  font-size: 22px;
  font-weight: 700;
`;
export default HeaderSpan;
